import React from 'react';
import SortListItem from './SortListItem';

const SortListDragPreview = ({ children, className, listClassName }) => (
  <ul
    className={`sort-list with-actions with-expansion drag-preview ${listClassName ||
        'pdf-default'}`}
  >
    <SortListItem className={className}>
      <div>{children}</div>
    </SortListItem>
  </ul>
);

export default SortListDragPreview;
